import { useEffect, useMemo } from "react";
import useCartData from "../cart/useCartData";
import useCartAction from "../cart/useCartAction";

const useCheckoutData = () => {

    const { getCart } = useCartAction();

    const {
        cartItems = [],
        sum = 0,
        vat = 0,
        total,
        addresses = [],
        carriers = [],
        ciCarriers = [],
        countries = [],
        loading,
    } = useCartData();

    useEffect(() => {
        getCart();
    }, [getCart]);

    const totalItems = useMemo(() => {
        return cartItems.reduce((acc, item) => acc + Number(item.quantity || 0), 0);
    }, [cartItems]);




    return {
        cartItems,
        addresses,
        carriers,
        ciCarriers,
        countries,
        loading,

        sum,
        vat,
        total,
        totalItems,
    };
};

export default useCheckoutData;